import { FC, useCallback, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import { useInterval } from 'react-use'
import StickyBanner from '@/components/StickyBanner'
import CountdownTimer from '@/views/bag/components/CountdownTimer'
import CountdownTimerSticky from '@/views/bag/components/CountdownTimerSticky'
import styles from './index.module.sass'

interface Props {
  endTime?: Date | number;
}

const CountdownBanner: FC<Props> = ({ endTime }) => {
  const { t } = useTranslation()
  const [isDone, setDone] = useState(false)
  const [showCountDown, setShowCountDown] = useState(false)
  const updateText = useCallback(() => {
    const endT = dayjs(endTime)
    if (!endTime || !endT.isValid() || dayjs().isAfter(endT)) {
      setDone(true)
      return
    }

    setDone(false)
    const diff = dayjs.duration(endT.diff(dayjs()))
    if (diff.asMilliseconds() <= 0) {
      setDone(true)
    }
  }, [endTime])

  const updateShow = useCallback(() => {
    const endT = dayjs(endTime)
    if (!endTime || !endT.isValid()) {
      setShowCountDown(false)
      return
    }
    const diff = dayjs.duration(endT.diff(dayjs()))
    if (diff.asHours() <= 24) {
      setShowCountDown(true)
    }
  }, [endTime])

  const update = useCallback(() => {
    updateText()
    updateShow()
  }, [updateText, updateShow])

  const isDoneText = useMemo(
    () => (isDone ? t('優惠已結束') : t('優惠時間剩餘')),
    [isDone, t]
  )

  useEffect(() => {
    updateText()
    updateShow()
  }, [])

  useInterval(update, 1000)

  if (!showCountDown) {
    return <div style={{ marginBottom: '12px' }} />
  }

  return (
    <StickyBanner>
      {
        ((isSticky: boolean) => {
          if (isSticky) {
            return (
              <div className={styles.sticky}>
                <div className={styles.descriptionIcon} />
                <div className={styles.description}>{isDoneText}</div>
                <CountdownTimerSticky endTime={endTime} />
              </div>
            )
          }
          return (
            <div className={styles.full}>
              <img
                className={styles.decoImage}
                src="/img/png/left_deco.png"
                alt=""
              />
              <div>
                <div className={styles.description}>{isDoneText}</div>
                <CountdownTimer endTime={endTime} />
              </div>
              <img
                className={styles.decoImage}
                src="/img/png/right_deco.png"
                alt=""
              />
            </div>
          )
        }) as never
      }
    </StickyBanner>
  )
}

export default CountdownBanner
